module.exports = __webpack_public_path__ + "media/images/favicon-68a09b165b3e798c293cc0ee778657ec.ico";